import React from 'react';

const WaterTemp = () => (
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00023 0C6.00023 0 1.23499 5.66973 0.56278 7.40595C0.202077 8.18182 0 9.04726 0 9.95923C0 13.2963 2.68631 16 6.00023 16C9.31392 16 12 13.2963 12 9.95923C12 9.04726 11.7979 8.18182 11.4377 7.40595C10.7648 5.66973 6.00023 0 6.00023 0Z"
      fill="#8CBCFF"
    />
  </svg>
);

export default WaterTemp;
